import { defineStore } from 'pinia';
import api from '@/api';
import useRouteStore from './route';
import useMenuStore from './menu';

interface UserState {
  account: string;
  name: string;
  avatar: string;
  password_strength: string;
  status: string;
  token: string;
  failure_time: string;
  merchant_type: string;
  has_shop: string;
  is_complete_entry: string;
  permissions: any[];
  merchant_id: string;
  business: string;
}

const useUserStore = defineStore('user', {
  state: (): UserState => ({
    account: localStorage.getItem('account') || '',
    name: localStorage.getItem('name') || '',
    avatar: localStorage.getItem('avatar') || '',
    password_strength: localStorage.getItem('password_strength') || '',
    status: localStorage.getItem('status') || '',
    token: localStorage.getItem('token') || '',
    failure_time: localStorage.getItem('failure_time') || '',
    merchant_type: localStorage.getItem('merchant_type') || '',
    is_complete_entry: localStorage.getItem('is_complete_entry') || '0',
    has_shop: localStorage.getItem('has_shop') || '0',
    permissions: [],
    merchant_id: localStorage.getItem('merchant_id') || '0',
    business:localStorage.getItem('business') || (localStorage.getItem('merchant_type') || '0')
  }),

  getters: {
    isLogin(state: UserState): boolean {
      let retn = false;
      if (state.token) {
        if (new Date().getTime() < parseInt(state.failure_time) * 1000) {
          retn = true;
        }
      }
      return retn;
    }
  },

  actions: {
    update(data: {status: string,merchant_type: string,is_complete_entry: string ;has_shop:string;merchant_id:string;}) {
      if (data.status) {
        localStorage.setItem('status', data.status);
        this.status = data.status;
      }
      
      if (data.merchant_type) {
        localStorage.setItem('merchant_type', data.merchant_type);
        this.merchant_type = data.merchant_type;
      }

      if (data.has_shop) {
        localStorage.setItem('has_shop', data.has_shop);
        this.has_shop = data.has_shop;
      }
      
      if (data.is_complete_entry) {
        localStorage.setItem('is_complete_entry', data.is_complete_entry);
        this.is_complete_entry = data.is_complete_entry;
      }

      if (data.merchant_id) {
        localStorage.setItem('merchant_id', data.merchant_id);
        this.merchant_id = data.merchant_id;
      }

    },
    feishuLogin(data: { account: string; name: string; avatar: string; password_strength: string; status: string; access_token: string; access_token_expire_time: number }) {
      localStorage.setItem('account', data.account);
      localStorage.setItem('name', data.name);
      localStorage.setItem('avatar', data.avatar);
      localStorage.setItem('password_strength', data.password_strength);
      localStorage.setItem('status', data.status.toString());
      localStorage.setItem('token', data.access_token);
      localStorage.setItem('failure_time', data.access_token_expire_time.toString());
      this.account = data.account;
      this.name = data.name;
      this.avatar = data.avatar;
      this.password_strength = data.password_strength;
      this.status = data.status.toString();
      this.token = data.access_token;
      this.failure_time = data.access_token_expire_time.toString();
    },

    login(data: { account: string; password: string; code:string }): Promise<any> {
      return new Promise((resolve, reject) => {
        api.post('/api/system/session', {
          account: data.account,
          password: data.password,
          code: data.code || ''
        }).then(res => {
          localStorage.setItem('account', res.data.account);
          localStorage.setItem('name', res.data.name);
          localStorage.setItem('avatar', res.data.avatar);
          localStorage.setItem('password_strength', res.data.password_strength);
          localStorage.setItem('status', res.data.status.toString());
          localStorage.setItem('token', res.data.access_token);
          localStorage.setItem('failure_time', res.data.access_token_expire_time.toString());
          localStorage.setItem("merchant_type",  res.data.merchant_type);
          localStorage.setItem("is_complete_entry",  res.data.is_complete_entry);
          localStorage.setItem("has_shop",  res.data.has_shop);
          localStorage.setItem("merchant_id",  res.data.merchant_id);

          this.account = res.data.account;
          this.name = res.data.name;
          this.avatar = res.data.avatar;
          this.password_strength = res.data.password_strength;
          this.status = res.data.status.toString();
          this.token = res.data.access_token;
          this.failure_time = res.data.access_token_expire_time.toString();
          this.merchant_type = res.data.merchant_type;
          this.is_complete_entry = res.data.is_complete_entry;
          this.has_shop = res.data.has_shop;
          this.merchant_id = res.data.merchant_id;
          setTimeout(() => {
            resolve(res.data);
          }, 100);
        }).catch(error => {
          reject(error);
        });
      });
    },
    info(merchant_id:string){
      return new Promise((resolve, reject) => {
        api.get('/api/system/session',{params:{merchant_id:merchant_id}}).then(res => {
          localStorage.setItem('account', res.data.account);
          localStorage.setItem('name', res.data.name);
          localStorage.setItem('avatar', res.data.avatar);
          localStorage.setItem('password_strength', res.data.password_strength);
          localStorage.setItem('status', res.data.status.toString());
          localStorage.setItem('token', res.data.access_token);
          localStorage.setItem('failure_time', res.data.access_token_expire_time.toString());
          localStorage.setItem("merchant_type",  res.data.merchant_type);
          localStorage.setItem("is_complete_entry",  res.data.is_complete_entry);
          localStorage.setItem("has_shop",  res.data.has_shop);
          localStorage.setItem("merchant_id",  res.data.merchant_id);

          this.account = res.data.account;
          this.name = res.data.name;
          this.avatar = res.data.avatar;
          this.password_strength = res.data.password_strength;
          this.status = res.data.status.toString();
          this.token = res.data.access_token;
          this.failure_time = res.data.access_token_expire_time.toString();
          this.merchant_type = res.data.merchant_type;
          this.is_complete_entry = res.data.is_complete_entry;
          this.has_shop = res.data.has_shop;
          this.merchant_id = res.data.merchant_id;
          setTimeout(() => {
            resolve(res.data);
          }, 100);
        }).catch(error => {
          reject(error);
        });
      });
    },

    register(data: { account: string; password: string; checkPassword: string; captcha: string; code: string }): Promise<any> {
      return new Promise((resolve, reject) => {
        api.post('/api/system/register', {
          account: data.account,
          password: data.password,
          check_password: data.checkPassword,
          captcha: data.captcha,
          code: data.code
        }).then(res => {
          localStorage.setItem('account', res.data.account);
          localStorage.setItem('name', res.data.name);
          localStorage.setItem('avatar', res.data.avatar);
          localStorage.setItem('password_strength', res.data.password_strength);
          localStorage.setItem('status', res.data.status.toString());
          localStorage.setItem('token', res.data.access_token);
          localStorage.setItem('failure_time', res.data.access_token_expire_time.toString());
          localStorage.setItem("is_complete_entry",  '0');
          localStorage.setItem("has_shop",  '0');
          this.account = res.data.account;
          this.name = res.data.name;
          this.avatar = res.data.avatar;
          this.password_strength = res.data.password_strength;
          this.status = res.data.status.toString();
          this.token = res.data.access_token;
          this.failure_time = res.data.access_token_expire_time.toString();
          this.is_complete_entry = '0';
          this.has_shop = '0';
          resolve(res.data);
        }).catch(error => {
          reject(error);
        });
      });
    },

    reset(data: { account: string; newPassword: string; checkPassword: string; captcha: string }): Promise<any> {
      return new Promise((resolve, reject) => {
        api.post('/api/system/reset', {
          account: data.account,
          password: data.newPassword,
          check_password: data.checkPassword,
          captcha: data.captcha
        }).then(res => {
          resolve(res.data);
        }).catch(error => {
          reject(error);
        });
      });
    },

    logout(): Promise<void> {
      return new Promise(resolve => {
        const routeStore = useRouteStore();
        const menuStore = useMenuStore();
        localStorage.removeItem('account');
        localStorage.removeItem('name');
        localStorage.removeItem('avatar');
        localStorage.removeItem('password_strength');
        localStorage.removeItem('status');
        localStorage.removeItem('token');
        localStorage.removeItem('failure_time');
        localStorage.removeItem('merchant_type');
        localStorage.removeItem('is_complete_entry');
        localStorage.removeItem('has_shop');
        localStorage.removeItem('merchant_id');
        localStorage.removeItem('business');
        this.account = '';
        this.name = '';
        this.avatar = '';
        this.password_strength = '';
        this.status = '';
        this.token = '';
        this.failure_time = '';
        this.merchant_type = '';
        this.is_complete_entry = '';
        this.has_shop = '';
        this.merchant_id = '';
        routeStore.removeRoutes();
        menuStore.setActived(0);
        resolve();
      });
    },

    obtainCode(data: { account: string; code_type: string; code: string }): Promise<any> {
      return new Promise((resolve, reject) => {
        api.post('/api/system/obtaincode', {
          account: data.account,
          code_type: data.code_type,
          code: data.code
        }).then(res => {
          resolve(res.data);
        }).catch(error => {
          reject(error);
        });
      });
    },

    getPermissions(): Promise<any[]> {
      return new Promise(resolve => {
        api.get('/api/system/permission/1', {}).then(res => {
          this.permissions = res.data.permissions;
          resolve(res.data.permissions);
        });
      });
    },

    updateUser(data: { avatar: string; name: string;originalPassword: string; password: string;checkPassword: string; update: string }): Promise<any> {
      return new Promise((resolve, reject) => {
        api.post('/api/user/update', {
          avatar: data.avatar,
          name: data.name,
          original_password: data.originalPassword,
          password: data.password,
          check_password: data.checkPassword,
          update: data.update
        }).then(res => {
          localStorage.setItem('account', res.data.account);
          localStorage.setItem('name', res.data.name);
          localStorage.setItem('password_strength', res.data.password_strength);  
          localStorage.setItem('avatar', res.data.avatar);
          this.account = res.data.account;
          this.name = res.data.name;
          this.password_strength = res.data.password_strength;
          this.avatar = res.data.avatar;
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    }
  }
});

export default useUserStore;